<template>
  <div class="col-lg-4 col-md-12 col-sm-12">
    <div class="body">
      <!-- 검색 기능 주석 (11/16) -->
      <!-- <input type="text" class="form-control" placeholder="search workflow" /> -->
      <h6>폴더</h6>

      <UserAddGroup />

      <div class="table-responsive">
        <table class="table table-filter m-b-0" id="groupListTabl">
          <tbody>
            <tr
              data-status="approved"
              v-for="(group, index) in groups"
              :key="group.groupCode"
              :class="{
                'table-active': group.groupCode == workflowStore.groupCode,
              }"
              @click="getWorkflowList(group.groupCode)"
            >
              <td width="300px" v-if="group.groupName.length > 15">
                {{ group.groupName.substr(0, 15) + " ..." }}
              </td>
              <td v-else>
                {{ group.groupName }}
              </td>
              <td>
                <span class="badge badge-info">{{ group.workflowCount }}</span>
              </td>
              <td>
                <button
                  class="header-dropdown btn btn-neutral"
                  v-if="group.groupName != '홈'"
                  v-click-outside="clickDropOutside"
                  @click.stop="showDropList(group.groupCode)"
                >
                  <span class="dropdown" data-toggle="dropdown" role="button">
                    <font-awesome-icon :icon="faCog"/>
<!--                    <i class="zmdi zmdi-settings"></i>-->
                    <ul
                      class="dropdown-menu dropdown-menu-right"
                      :class="{ show: group.groupCode == groupDropCode }"
                    >
                      <li @click="showModal(index, 'rename', 'open')">
                        <a>이름수정</a>
                      </li>
                      <li
                        @click="
                          deleteGroup(group.groupCode, group.workflowCount)
                        "
                      >
                        <a>삭제</a>
                      </li>
                    </ul>
                  </span>
                </button>
              </td>
            </tr>
            <tr class="lastTr" colspan="3">
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import vClickOutside from "v-click-outside";
import UserAddGroup from "@/views/user/group/UserAddGroup";
import eventbus from "@/store/modules/devEventBus";

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {faCog} from "@fortawesome/free-solid-svg-icons";

export default {
  name: "group",
  directives: {
    clickOutside: vClickOutside.directive,
  },
  components: {
    UserAddGroup,
    FontAwesomeIcon,
  },
  data() {
    return {
      groupName: "",
      groupCode: "",
      groupDropCode: "",
      groups: [],

      faCog,
    };
  },
  watch : {
    // getGroups(groups){
    //   console.log("ㅇㅇㅇ??", groups)
    //
    //
    //
    //
    //
    //   // console.log(groups)
    //   //
    //   //
    //   // var param = { userCode: this.$store.state.userStore.usercode };
    //   // this.api.getGroupList(param).then((res) => {
    //   //
    //   //   // if(this.utils.preApiHandle(res)) {
    //   //   //   console.log("dev create page res : ", res)
    //   //   // }
    //   //
    //   //
    //   //
    //   //   console.log("getGroupList res : ", res);
    //   //   if (res["code"] == 0) {
    //   //
    //   //     this.$store.dispatch("saveGroups", res.groups)
    //   //
    //   //
    //   //     this.groups = res.groups;
    //   //     // this.$store.dispatch("saveGroups", res.groups)
    //   //   }
    //   // });
    //
    //
    //
    //
    // },
    // storeGroups() {
    //   this.groups = this.storeGroups;
    // }
  },
  computed: {
    getGroups(){
      console.log("그룹 상태 ")

      this.getGroupList();




      return this.$store.getters.getGroups;
    },
    userStore() {
      return this.$store.state.userStore;
    },
    workflowStore() {
      return this.$store.state.workflowStore;
    },
    storeGroups() {
      return this.workflowStore.groups;
    },
  },

  methods: {
    showDropList(code) {
      if (this.groupDropCode != code) {
        this.groupDropCode = code;
      } else {
        this.groupDropCode = "";
      }
    },
    getGroupList() {
      var param = { userCode: this.$store.getters.getUserCode };
      this.api.getGroupList(param).then((res) => {

        if(this.utils.preApiHandle(res)) {
          console.log("dev create page res : ", res)
        }

        console.log("getGroupList res : ", res);
        if (res["code"] == 0) {

          this.$store.dispatch("saveGroups", res.groups)


          this.groups = res.groups;

          console.log("dddd!!!!!!!!!!!!!!!", res.groups.length)
          if(res.groups.length == 0){
            console.log("없음")
          }





          // this.$store.dispatch("saveGroups", res.groups)
        }
      });
    },
    deleteGroup(code, count) {
      var yn = false;

      if (count > 0) {
        yn = confirm(
          "해당 폴더에 있는 워크플로우들은 '홈' 폴더로 이동하게 됩니다.\n그래도 삭제하시겠습니까?"
        );
      } else {
        yn = confirm("삭제 하시겠습니까?");
      }

      if (yn) {
        const homeCode = this.getHomeCode();
        var param = {
          groupCode: code,
          workCount: count,
          homeCode: homeCode,
        };

        console.log("tkrwp ",param)

        this.api.deleteGroup(param).then((res) => {
          console.log("deleteGroup res : ", res);

          if(this.utils.preApiHandle(res)) {
            console.log("profile edit res : ", res)
          }

          if (res["code"] == 0) {
            alert("삭제 되었습니다.");
            this.getGroupList();
            this.getWorkflowList2(homeCode);
          } else {
            console.log(res["code"])
          }
        });

      }
    },
    getWorkflowList2(code) {

      this.$store.dispatch("saveGroupCode", code)

      var param = { userCode: this.userStore.userCode, groupCode: code };
      this.api.getWorkflowList(param).then((res) => {
        console.log("getWorkflowList res : ", res);

        if(this.utils.preApiHandle(res)) {
          console.log("profile edit res : ", res)
        }

        if (res["code"] == 0) {

          var workflows = res.workflows;
          for (var i = 0; i < workflows.length; i++) {
            var schema = JSON.parse(workflows[i].workflowSchema);
            workflows[i].startImage = ""
            workflows[i].endImage = ""
            if (schema.workflows[0].api.appImage != undefined) {
              workflows[i].startImage = schema.workflows[0].api.appImage;
            }
            if (schema.workflows[schema.workflows.length - 1].api.appImage != undefined) {
              workflows[i].endImage = schema.workflows[schema.workflows.length - 1].api.appImage;
            }
          }

          this.$store.dispatch("saveWorkflows", res.workflows)

        }
      });

      this.$store.dispatch("saveGroupCode", code);

    },
    getWorkflowList(code) {

      this.$store.dispatch("saveGroupCode", code)

      // var param = { userCode: this.userStore.userCode, groupCode: code };
      // this.api.getWorkflowList(param).then((res) => {
      //   console.log("getWorkflowList res : ", res);
      //   if (res["code"] == 0) {
      //
      //     var workflows = res.workflows;
      //     for (var i = 0; i < workflows.length; i++) {
      //       var schema = JSON.parse(workflows[i].workflowSchema);
      //       workflows[i].startImage = ""
      //       workflows[i].endImage = ""
      //       if (schema.workflows[0].api.appImage != undefined) {
      //         workflows[i].startImage = schema.workflows[0].api.appImage;
      //       }
      //       if (schema.workflows[schema.workflows.length - 1].api.appImage != undefined) {
      //         workflows[i].endImage = schema.workflows[schema.workflows.length - 1].api.appImage;
      //       }
      //     }
      //
      //     this.$store.dispatch("saveWorkflows", res.workflows)
      //
      //   }
      // });
      //
      // this.$store.dispatch("saveGroupCode", code);

    },
    showModal(i, tag, status) {
      var code = this.workflowStore.groups[i].groupCode;
      var name = this.workflowStore.groups[i].groupName;

      var param = { title: "폴더명", groupCode: code, groupName: name };

      this.$store.dispatch("showModal", {
        params: param,
        tag: tag,
        status: status,
      });

      document.getElementsByClassName("overlay")[0].style.display = "block";
    },
    getHomeCode() {
      const groups = this.workflowStore.groups;
      for (var i = 0; i < groups.length; i++) {
        if (groups[i].groupName == "홈") {
          return groups[i].groupCode;
        }
      }
    },
    clickDropOutside() {
      if (this.groupDropCode == "") {
        return;
      }

      this.groupDropCode = "";
    },
  },
  created() {

    eventbus.$on('groupList', ()=>{
      this.getGroupList();

    })

    this.getGroupList();
  },
};
</script>
